
import { Vue } from 'vue-property-decorator'
import store from '../store'
import Component from 'vue-class-component'
import * as db from '@shared/types/database'

@Component
export default class TestGetters extends Vue {
  get testId () {
    return this.$route.params.testId
  }

  get test () {
    const mgtTest = store.getters.workspace.getMgtTestById(this.testId)
    return mgtTest?.data as db.Test
  }

  get isTestComplete () {
    return [db.TestStatus.Complete].includes(this.status)
  }

  get isTestDraft () {
    return [db.TestStatus.Draft].includes(this.status)
  }

  get isTestInReview () {
    return [db.TestStatus.InReview].includes(this.status)
  }

  get testTitle () {
    return this.test?.payload.title
  }

  get testObjective () {
    return this.test?.payload.objective ?? ''
  }

  get testDecisionContext () {
    return this.test?.payload.decisionContext ?? ''
  }

  get testComments () {
    return this.test?.payload.comments
  }

  get status () {
    return this.test?.payload.status
  }

  get testType () {
    return this.test?.payload.testType
  }

  get testTemplateId () {
    return this.test?.payload.testTemplateId ?? -1
  }

  get customerQuestions () {
    return this.test?.payload.customerQuestions
  }

  get testAssets () {
    return this.test?.payload.prototypes
  }

  get testAudienceInfo () {
    return this.test?.payload.segment
  }

  get projects () {
    return store.getters.workspace.getProjectsByTestId(this.testId)
  }

  get relatedTests () {
    const uniqueRelatedTests = this.projects.reduce((acc, project) => {
      project.ids.forEach(id => {
        acc[id] = true
      })
      return acc
    }, {} as Record<string, boolean>)

    if (this.test?.payload.relatedIds) { // test is a clone of a previous test
      this.test.payload.relatedIds.forEach(id => {
        uniqueRelatedTests[id] = true
      })
    }

    return Object.keys(uniqueRelatedTests).reduce((acc, id) => {
      const test = store.getters.workspace.tests.find(t => {
        return t.id === parseInt(id) && t.id !== this.test.id
      })
      if (test) acc.push(test)
      return acc
    }, [] as db.Test[])
  }
}
